/**
 * Mirrors backend `UserView` at backend/src/lib/userView.ts:40-57 (TASK-078 Phase 0b).
 *
 * BACKEND CONTRACT SOURCE: backend/src/lib/userView.ts (interface UserView)
 * SYNC POLICY: manual; drift detected by frontend/tests/api/schemas/users.test.ts
 *
 * REGRESSION DOCSTRING: frontend/tests/pages/UsersPage.test.jsx:1-15 documents the
 * production bug where `email: undefined` rendered blank cells. Zod rejects undefined
 * here — `email` is the one REQUIRED field on the row schema specifically because of
 * that regression.
 *
 * Other identifying fields are optional: legacy responses ship only `cognitoSub`,
 * post-Phase-0b ships `userId`/`sub`. The page-side normalizer collapses these to
 * a single `sub`. We accept any combination so existing fixtures + production
 * payloads validate.
 */
import { z } from 'zod';

export const UserViewSchema = z.looseObject({
  userId: z.string().min(1).optional(),
  cognitoSub: z.string().min(1).optional(),
  sub: z.string().min(1).optional(),
  email: z.email(),
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  opcoId: z.string().nullable().optional(),
  opcoName: z.string().nullable().optional(),
  role: z.string().min(1).optional(),
  status: z.string().min(1).optional(),
  lastLoginAt: z.string().nullable().optional(),
  createdAt: z.string().optional(),
});

export type UserView = z.infer<typeof UserViewSchema>;

/** GET /api/admin/users — `{ users: UserView[] }`. */
export const UsersListResponseSchema = z.looseObject({
  users: z.array(UserViewSchema),
});

export type UsersListResponse = z.infer<typeof UsersListResponseSchema>;
